"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mds = exports.createMDSTheme = void 0;
var _lodash = _interopRequireDefault(require("lodash.merge"));
var _colors = _interopRequireDefault(require("./colors"));
var _typography = _interopRequireDefault(require("./typography"));
var _spacing = _interopRequireDefault(require("./spacing"));
var _elevation = _interopRequireDefault(require("./elevation"));
const menuSizes = {
  expanded: '236px',
  collapsed: '56px'
};
const createMDSTheme = (primitives = {}, overrides = {}, extra = {}) => {
  const colors = (0, _lodash.default)(_colors.default, primitives.colors);
  const typography = (0, _lodash.default)(_typography.default, primitives.typography);
  const spacing = (0, _lodash.default)(_spacing.default, primitives.spacing);
  const elevation = (0, _lodash.default)(_elevation.default, primitives.elevation);
  const theme = {
    name: 'mds',
    fonts: {
      preferred: '"McKinseySans", "Verdana", sans-serif',
      secondary: '"Bower Bold"'
    },
    fontSizes: {
      base: '1rem'
    },
    typography,
    spacing,
    elevation,
    AppFrame: {
      bellWidget: {
        width: '392px',
        boxShadow: elevation.sm,
        header: {
          fontFamily: typography.textLarge.fontFamily,
          fontSize: typography.textLarge.fontSize,
          fontWeight: typography.textLarge.fontWeight,
          lineHeight: typography.textLarge.lineHeight,
          height: '50px',
          padding: `${spacing.s3} ${spacing.m1}`,
          textAlign: 'left',
          textTransform: 'capitalize'
        },
        footer: {
          fontFamily: typography.textDefault.fontFamily,
          fontSize: typography.textDefault.fontSize,
          fontWeight: typography.textDefault.fontWeight,
          lineHeight: typography.textDefault.lineHeight,
          height: '56px'
        },
        placeholder: {
          fontFamily: typography.textDefault.fontFamily,
          fontSize: typography.textDefault.fontSize,
          fontWeight: typography.textDefault.fontWeight,
          lineHeight: typography.textDefault.lineHeight
        }
      },
      header: {
        height: '60px',
        searchPanel: {
          inputHeight: '22px',
          inputLeftMaring: '4px',
          selectedCharFontWeight: 500
        },
        nav: {
          iconPadding: '0 9px'
        }
      },
      menu: {
        expandedWidth: menuSizes.expanded,
        collapsedWidth: menuSizes.collapsed,
        border: '1px',
        header: {
          height: '48px'
        },
        itemContainer: {
          padding: '16px 16px 16px 32px',
          paddingLeft: '24px',
          collapsedPadding: '12px 0',
          height: 'auto',
          badgeHeight: '100%',
          width: menuSizes.expanded,
          marginBottom: '6px'
        },
        itemTitle: {
          fontSize: '16px',
          fontWeight: '300',
          fontWeightBold: '500',
          letterSpacing: '0',
          lineHeight: '24px',
          color: colors.neutral.black,
          opacity: '1',
          hover: {
            color: colors.neutral.neutral80
          }
        },
        itemIcon: {
          width: menuSizes.collapsed,
          opacity: 1,
          lineHeight: '32px',
          margin: '0'
        },
        itemArrowContainer: {
          width: '48px',
          height: '100%',
          border: '0'
        },
        itemArrow: {
          width: '24px',
          height: '24px'
        },
        submenu: {
          width: '236px',
          sectionPadding: '14px 24px',
          dividerHeight: '0',
          sectionFontSize: '16px',
          sectionFontWeight: '300',
          sectionLetterSpacing: '0',
          sectionLineHeight: '24px',
          sectionTextTransform: 'none',
          sectionTitleOpacity: '1'
        },
        footer: {
          horizontalPadding: '16px'
        }
      },
      breadcrumbs: {
        fontSize: typography.textSmall.fontSize,
        fontFamily: typography.textSmall.fontFamily,
        fontWeight: typography.textSmall.fontWeight,
        lineHeight: typography.textSmall.lineHeight,
        popover: {
          shadow: elevation.sm,
          padding: '10px 0',
          itemPadding: '6px 16px',
          itemFontFamily: typography.textSmall.fontFamily,
          itemFontSize: typography.textSmall.fontSize,
          itemFontWeight: typography.textSmall.fontWeight,
          itemLineHeight: typography.textSmall.lineHeight
        }
      },
      snack: {
        fontSize: '16px',
        fontWeight: typography.textDefault.fontWeight,
        containerWidth: '392px',
        closeBtnHeight: '16px',
        closeBtnWidth: '16px',
        readBtnHeight: '8px',
        readBtnWidth: '8px',
        topPadding: '16px',
        body: {
          fontSize: '16px',
          fontWeight: typography.textLarge.fontWeight,
          lineHeight: typography.textLarge.lineHeight,
          padding: '20px',
          contentMargin: '0 20px'
        },
        timestamp: {
          fontSize: '12px',
          fontWeight: typography.textSmall.fontWeight,
          lineHeight: typography.textSmall.lineHeight
        },
        button: {
          fontSize: typography.textSmall.fontSize,
          fontWeight: typography.textSmall.fontWeight,
          lineHeight: typography.textSmall.lineHeight,
          height: '32px',
          btnMargin: `${spacing.s3} ${spacing.s3} 0 0`,
          border: colors.neutral.neutral20
        },
        placeholder: {
          fontSize: '16px',
          fontWeight: typography.textLarge.fontWeight
        }
      }
    },
    buttons: {
      fontFamily: typography.textDefault.fontFamily,
      default: {
        fontSize: typography.textDefault.fontSize,
        fontWeight: typography.textDefault.fontWeight,
        height: '40px',
        width: 'auto',
        minWidth: '120px',
        minWidthIconOnly: '48px',
        textTransform: 'none',
        textTransformFirstLetter: 'capitalize',
        letterSpacing: '0',
        lineHeight: '20px',
        padding: '7px 16px'
      },
      inline: {
        fontSize: typography.textSmall.fontSize,
        fontWeight: typography.textSmall.fontWeight,
        height: '32px',
        width: 'auto',
        minWidth: '120px',
        minWidthIconOnly: '48px',
        textTransform: 'none',
        textTransformFirstLetter: 'capitalize',
        letterSpacing: '0',
        lineHeight: '24px',
        padding: '5px 16px',
        iconPadding: '12px',
        borderRadius: '0',
        boxShadow: elevation.none,
        margin: '0px 2px',
        dropdownButtonPadding: '7px 8px 7px 12px',
        dropdownButtonIconMargin: '0 0 0 4px',
        splitDropdownDropPadding: '4px'
      },
      link: {
        fontSize: typography.textSmall.fontSize,
        fontWeight: typography.textSmall.fontWeight,
        textTransform: 'none',
        letterSpacing: '0',
        lineHeight: '20px'
      }
    },
    buttonGroup: {
      groupMarginFramed: '12px',
      groupMarginInline: '12px',
      groupPadding: 0,
      contextMenu: {
        trigger: {
          width: '48px',
          margin: 0,
          borderWidth: '1px',
          borderStyle: 'solid'
        },
        popup: {
          padding: '8px 0'
        },
        item: {
          fontFamily: typography.textSmall.fontFamily,
          fontSize: typography.textSmall.fontSize,
          fontWeight: typography.textSmall.fontWeight,
          lineHeight: typography.textSmall.lineHeight,
          letterSpacing: typography.textSmall.letterSpacing,
          height: '40px',
          textTransform: 'capitalize',
          borderWidth: '0',
          borderStyle: 'solid'
        }
      }
    },
    card: {
      borderRadius: 'none',
      title: {
        fontSize: typography.heading3.fontSize,
        fontWeight: typography.heading3.fontWeight,
        lineHeight: typography.heading3.lineHeight
      },
      description: {
        fontWeight: typography.textDefault.fontWeight
      }
    },
    modals: {
      padding: '40px',
      headerHeight: 'auto',
      headerPadding: '12px 0 24px',
      headerTitlePosition: 'center',
      confirmAlignment: 'start',
      borderRadius: '0px',
      title: {
        fontFamily: typography.heading6.fontFamily,
        fontSize: typography.heading6.fontSize,
        fontWeight: typography.heading6.fontWeight,
        lineHeight: typography.heading6.lineHeight,
        textTransform: 'initial',
        padding: '0',
        actionsTop: '16px',
        actionsRight: '16px'
      },
      content: {
        padding: '0 0 12px',
        fontFamily: typography.textSmall.fontFamily,
        fontSize: typography.textSmall.fontSize,
        fontWeight: typography.textSmall.fontWeight,
        lineHeight: typography.textSmall.lineHeight
      }
    },
    accordion: {
      badge: {
        fontSize: '12px',
        fontFamily: typography.textDefault.fontFamily,
        fontWeight: typography.textDefault.fontWeight,
        lineHeight: '16px',
        letterSpacing: typography.textDefault.letterSpacing,
        height: '16px',
        borderRadius: '16px',
        padding: '0 8px',
        right: '45px'
      },
      arrowIcon: {
        height: '24px',
        width: '24px'
      },
      header: {
        fontSize: typography.textDefault.fontSize,
        fontFamily: typography.textDefault.fontFamily,
        fontWeight: 500,
        lineHeight: typography.textDefault.lineHeight,
        letterSpacing: typography.textDefault.letterSpacing,
        textTransform: typography.textDefault.textTransform,
        borderTopWidth: '1px',
        borderBottomWidth: '1px',
        borderBottomWidthActive: '0px',
        height: '56px',
        padding: '16px 24px'
      }
    },
    panel: {
      fontSize: typography.textDefault.fontSize,
      fontFamily: typography.textDefault.fontFamily,
      fontWeight: typography.textDefault.fontWeight,
      lineHeight: '40px',
      letterSpacing: typography.textDefault.letterSpacing,
      textTransform: 'capitalize'
    },
    numberField: {
      fontSize: typography.textSmall.fontSize,
      fontFamily: typography.textSmall.fontFamily,
      fontWeight: typography.textSmall.fontWeight,
      lineHeight: typography.textSmall.lineHeight,
      letterSpacing: typography.textSmall.letterSpacing,
      height: '32px',
      label: {
        fontSize: typography.textSmall.fontSize,
        fontFamily: typography.textSmall.fontFamily,
        fontWeight: typography.textSmall.fontWeight,
        lineHeight: typography.textSmall.lineHeight,
        letterSpacing: typography.textSmall.letterSpacing,
        marginBottom: '8px'
      },
      description: {
        fontSize: '12px',
        fontWeight: '400',
        marginTop: '4px'
      },
      error: {
        fontSize: '12px',
        fontWeight: '400',
        lineHeight: '16px'
      }
    },
    numericInput: {
      fontSize: typography.textSmall.fontSize,
      fontFamily: typography.textSmall.fontFamily,
      fontWeight: typography.textSmall.fontWeight,
      lineHeight: typography.textSmall.lineHeight,
      letterSpacing: typography.textSmall.letterSpacing,
      height: '32px',
      padding: '0 15px',
      label: {
        fontSize: typography.textSmall.fontSize,
        fontFamily: typography.textSmall.fontFamily,
        fontWeight: typography.textSmall.fontWeight,
        lineHeight: typography.textSmall.lineHeight,
        letterSpacing: typography.textSmall.letterSpacing,
        marginBottom: '8px'
      },
      description: {
        fontSize: '12px',
        fontWeight: '400',
        marginTop: '4px'
      },
      error: {
        fontSize: '12px',
        fontWeight: '400',
        lineHeight: '16px'
      }
    },
    radio: {
      fontSize: typography.textSmall.fontSize,
      fontFamily: typography.textSmall.fontFamily,
      fontWeight: typography.textSmall.fontWeight,
      lineHeight: typography.textSmall.lineHeight,
      size: '18px',
      labelShift: '8px',
      bottomMargin: '8px',
      label: {
        fontSize: typography.textSmall.fontSize,
        fontFamily: typography.textSmall.fontFamily,
        fontWeight: typography.textSmall.fontWeight,
        lineHeight: typography.textSmall.lineHeight,
        marginBottom: '8px'
      },
      error: {
        fontSize: '12px',
        fontWeight: '400',
        lineHeight: '16px'
      }
    },
    switch: {
      fontSize: typography.textSmall.fontSize,
      fontFamily: typography.textSmall.fontFamily,
      fontWeight: typography.textSmall.fontWeight,
      lineHeight: typography.textSmall.lineHeight,
      thumbSize: '14px',
      hoverThumbSize: '14px',
      thumbShift: '3px',
      labelShift: '8px',
      width: '40px',
      height: '20px',
      radius: '20px',
      label: {
        fontSize: typography.textSmall.fontSize,
        fontFamily: typography.textSmall.fontFamily,
        fontWeight: typography.textSmall.fontWeight,
        lineHeight: typography.textSmall.lineHeight,
        marginBottom: '8px'
      },
      error: {
        fontSize: '12px',
        fontWeight: '400',
        lineHeight: '16px'
      }
    },
    tagsInput: {
      fontSize: typography.textSmall.fontSize,
      fontFamily: typography.textSmall.fontFamily,
      fontWeight: typography.textSmall.fontWeight,
      lineHeight: '22px',
      height: '22px',
      letterSpacing: typography.textSmall.letterSpacing,
      tagBorderRadius: '2px',
      containerPadding: '0 3px',
      containerGap: '5px',
      inputPadding: '0 4px',
      tagHeight: '22px',
      tagInnerPadding: '4px 8px',
      tagInnerGap: '8px',
      placeholder: {
        fontSize: typography.textSmall.fontSize,
        fontWeight: typography.textSmall.fontWeight,
        lineHeight: typography.textSmall.lineHeight,
        letterSpacing: typography.textSmall.letterSpacing
      },
      label: {
        fontSize: typography.textSmall.fontSize,
        fontWeight: typography.textSmall.fontWeight,
        lineHeight: typography.textSmall.lineHeight,
        letterSpacing: typography.textSmall.letterSpacing,
        marginBottom: '8px'
      },
      description: {
        fontSize: '12px',
        fontWeight: '400',
        lineHeight: typography.textSmall.lineHeight,
        letterSpacing: typography.textSmall.letterSpacing,
        marginTop: '4px'
      },
      error: {
        fontSize: '12px',
        fontWeight: '400',
        lineHeight: '16px'
      }
    },
    dateDropdown: {
      fontSize: typography.textSmall.fontSize,
      fontFamily: typography.textSmall.fontFamily,
      fontWeight: typography.textSmall.fontWeight,
      lineHeight: '17px',
      letterSpacing: typography.textSmall.letterSpacing,
      height: '32px',
      padding: '8px 16px',
      label: {
        fontSize: typography.textSmall.fontSize,
        fontWeight: typography.textSmall.fontWeight,
        lineHeight: typography.textSmall.lineHeight,
        letterSpacing: typography.textSmall.letterSpacing,
        marginBottom: '8px'
      },
      description: {
        fontSize: '12px',
        fontFamily: typography.textSmall.fontFamily,
        fontWeight: typography.textSmall.fontWeight,
        lineHeight: '16px',
        letterSpacing: typography.textSmall.letterSpacing,
        marginTop: '4px'
      },
      error: {
        fontSize: '12px',
        fontWeight: '400',
        lineHeight: '16px'
      }
    },
    calendar: {
      borderRadius: '0px',
      width: '300px',
      monthControls: {
        height: '44px',
        padding: '16px 24px 8px',
        margin: '8px 0 0',
        borderBottomWidth: '0px',
        label: {
          fontSize: typography.textDefault.fontSize,
          fontFamily: typography.textDefault.fontFamily,
          fontWeight: typography.textDefault.fontWeight,
          lineHeight: typography.textDefault.lineHeight,
          letterSpacing: typography.textDefault.letterSpacing
        }
      },
      weekDays: {
        padding: '0px 24px',
        label: {
          fontSize: typography.textSmall.fontSize,
          fontFamily: typography.textSmall.fontFamily,
          fontWeight: 500,
          lineHeight: '28px',
          letterSpacing: typography.textSmall.letterSpacing
        }
      },
      days: {
        containerPadding: '0px 24px 24px',
        width: '36px',
        height: '36px',
        margin: '0px',
        padding: '0px',
        borderRadius: '0px',
        label: {
          fontSize: typography.textSmall.fontSize,
          fontFamily: typography.textSmall.fontFamily,
          fontWeight: 300,
          lineHeight: typography.textSmall.lineHeight,
          letterSpacing: typography.textSmall.letterSpacing
        }
      },
      year: {
        fontSize: typography.textSmall.fontSize,
        fontFamily: typography.textSmall.fontFamily,
        fontWeight: 300,
        lineHeight: '32px',
        letterSpacing: typography.textSmall.letterSpacing
      },
      time: {
        inputsPadding: '0 24px',
        buttonPadding: '12px 24px 24px'
      }
    },
    datePicker: {
      fontSize: typography.textSmall.fontSize,
      fontFamily: typography.textSmall.fontFamily,
      fontWeight: typography.textSmall.fontWeight,
      caption: {
        fontSize: typography.textSmall.fontSize,
        fontFamily: typography.textSmall.fontFamily,
        fontWeight: typography.textSmall.fontWeight,
        lineHeight: typography.textSmall.lineHeight
      },
      weekdays: {
        fontSize: typography.textSmall.fontSize,
        fontFamily: typography.textSmall.fontFamily,
        fontWeight: 500
      }
    },
    textField: {
      fontSize: typography.textSmall.fontSize,
      fontFamily: typography.textSmall.fontFamily,
      fontWeight: typography.textSmall.fontWeight,
      lineHeight: '17px',
      borderWidth: '1px',
      height: '32px',
      inputPadding: '6px 16px',
      areaPadding: '6px 16px',
      label: {
        fontSize: typography.textSmall.fontSize,
        fontWeight: typography.textSmall.fontWeight,
        lineHeight: typography.textSmall.lineHeight,
        marginBottom: '8px'
      },
      description: {
        fontSize: '12px',
        fontWeight: '400',
        marginTop: '4px'
      },
      error: {
        fontSize: '12px',
        fontWeight: '400',
        marginTop: '4px'
      },
      passwordIcon: {
        height: '16px',
        width: '16px'
      }
    },
    toast: {
      fontSize: typography.textDefault.fontSize,
      fontFamily: typography.textDefault.fontFamily,
      fontWeight: 500,
      lineHeight: '21px',
      letterSpacing: typography.textDefault.letterSpacing,
      iconHeight: '24px',
      iconWidth: '24px',
      iconMargin: `0 ${spacing.s4} 0 ${spacing.m1}`,
      toastContainerHeight: '56px',
      buttonBorder: '1px solid #fff',
      buttonBorderHover: '1px solid #fff',
      buttonBorderActive: '1px solid #fff',
      warnBorder: '1px solid #000',
      btnContainerHeight: 'auto',
      btnContainerMargin: `0 ${spacing.m1} 0 ${spacing.s1}`,
      btnActionMargin: `0 ${spacing.s3} 0 0`
    },
    tooltip: {
      fontFamily: typography.textSmall.fontFamily,
      fontSize: typography.textSmall.fontSize,
      fontWeight: typography.textSmall.fontWeight,
      lineHeight: typography.textSmall.lineHeight,
      letterSpacing: 'initial',
      padding: '5px 12px',
      borderRadius: '0px'
    },
    checkbox: {
      fontSize: typography.textSmall.fontSize,
      fontFamily: typography.textSmall.fontFamily,
      fontWeight: typography.textSmall.fontWeight,
      lineHeight: typography.textSmall.lineHeight,
      size: '18px',
      bottomMargin: '4px',
      labelShift: '8px',
      borderRadius: '0',
      label: {
        fontFamily: typography.textSmall.fontFamily,
        fontSize: typography.textSmall.fontSize,
        fontWeight: typography.textSmall.fontWeight,
        lineHeight: typography.textSmall.lineHeight,
        marginBottom: '8px'
      },
      error: {
        fontFamily: typography.textSmall.fontFamily,
        fontSize: '12px',
        fontWeight: '400',
        lineHeight: '16px'
      }
    },
    contextMenu: {
      fontSize: typography.textDefault.fontSize,
      fontFamily: typography.textDefault.fontFamily,
      fontWeight: typography.textSmall.fontWeight,
      lineHeight: typography.textDefault.lineHeight,
      letterSpacing: typography.textDefault.letterSpacing,
      width: '200px',
      itemHeight: '32px',
      containerPadding: '8px 0',
      menuItemPadding: '4px 16px',
      menuItemMargin: '0',
      menuItemBorderRadius: '0px',
      borderRadius: '0px',
      dividerMargin: '8px 0px',
      submenuTop: '-8px',
      submenuArrowIcon: {
        height: '16px',
        width: '16px',
        arrowMargin: '0 0 0 12px'
      },
      toggler: {
        display: 'flex',
        width: '48px',
        height: '40px',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center'
      }
    },
    dropdown: {
      fontSize: typography.textSmall.fontSize,
      fontFamily: typography.textSmall.fontFamily,
      fontWeight: typography.textSmall.fontWeight,
      lineHeight: typography.textSmall.lineHeight,
      marginLeft: '24px',
      height: '32px',
      padding: '0 16px',
      borderWidth: '1px',
      label: {
        fontFamily: typography.textSmall.fontFamily,
        fontSize: typography.textSmall.fontSize,
        fontWeight: typography.textSmall.fontWeight,
        lineHeight: typography.textSmall.lineHeight,
        marginBottom: '8px'
      },
      description: {
        fontSize: '12px',
        fontWeight: '400',
        marginTop: '4px'
      },
      error: {
        fontSize: '12px',
        fontWeight: '400',
        lineHeight: '16px'
      },
      tag: {
        borderRadius: '4px',
        fontSize: typography.textSmall.fontSize,
        fontFamily: typography.textSmall.fontFamily,
        fontWeight: typography.textSmall.fontWeight,
        height: '24px',
        margin: '4px',
        padding: '0 30px 0 10px'
      },
      options: {
        padding: '8px 0',
        shadow: elevation.sm,
        itemHeight: '32px',
        itemPadding: '0 16px',
        selectedFontWeight: '500',
        borderRadius: '0px',
        selectedIcon: {
          height: '16px',
          width: '16px'
        }
      }
    },
    filterLayout: {
      fontSize: typography.textSmall.fontSize,
      fontFamily: typography.textSmall.fontFamily,
      fontWeight: typography.textSmall.fontWeight,
      lineHeight: typography.textSmall.lineHeight,
      headerPadding: '0 16px',
      bodyPadding: '0px',
      boxShadow: elevation.sm,
      applyPadding: '0 4px 4px 4px',
      borderRadius: '0px',
      containerWidth: '250px'
    },
    inlineDropdown: {
      fontSize: typography.textSmall.fontSize,
      fontFamily: typography.textSmall.fontFamily,
      fontWeight: typography.textSmall.fontWeight,
      lineHeight: typography.textSmall.lineHeight,
      selectedFontWeight: '500',
      boxShadow: elevation.sm,
      itemHeight: '40px',
      itemPadding: '0 16px',
      width: '165px'
    },
    tabs: {
      label: {
        fontSize: typography.textDefault.fontSize,
        fontFamily: typography.textDefault.fontFamily,
        fontWeight: typography.textDefault.fontWeight,
        lineHeight: typography.textDefault.lineHeight,
        letterSpacing: typography.textDefault.letterSpacing,
        primaryHeight: '56px',
        primaryFontWeight: typography.textDefault.fontWeight,
        primaryPadding: `${spacing.s4} ${spacing.m1}`,
        secondaryPadding: `${spacing.m1} 0`,
        secondaryHeight: '72px'
      },
      navigation: {
        primaryPosition: 'flex-start',
        secondaryPosition: 'flex-start',
        primaryPaddingTop: '8px'
      },
      badge: {
        lineHeight: '16px',
        fontWeight: typography.textDefault.fontWeight,
        borderRadius: '16px',
        height: '16px'
      },
      spacingBetweenTabs: spacing.m1
    },
    verticalTabs: {
      fontSize: typography.textDefault.fontSize,
      fontFamily: typography.textDefault.fontFamily,
      fontWeight: typography.textDefault.fontWeight,
      lineHeight: '40px',
      letterSpacing: typography.textDefault.letterSpacing
    },
    pagination: {
      fontSize: typography.textSmall.fontFamily,
      fontFamily: typography.textSmall.fontFamily,
      fontWeight: typography.textSmall.fontWeight,
      lineHeight: typography.textSmall.lineHeight,
      letterSpacing: typography.textSmall.letterSpacing,
      currentPage: {
        width: '32px',
        height: '32px',
        border: '1px solid #b3b3b3',
        activeBorder: '1px solid #2251ff'
      },
      topPagination: {
        dropdownMinWidth: '78px'
      },
      bottomPagination: {
        fontSize: '14px',
        fontFamily: typography.textSmall.fontFamily,
        fontWeight: typography.textSmall.fontWeight,
        lineHeight: typography.textSmall.lineHeight,
        letterSpacing: typography.textSmall.letterSpacing,
        itemPadding: '0 4px',
        itemMargin: '0 4px',
        padding: '16px 0',
        activeItem: {
          fontWeight: 500
        }
      },
      action: {
        height: 10,
        width: 5.5
      }
    },
    table: {
      header: {
        fontFamily: typography.textSmall.fontFamily,
        fontSize: typography.textSmall.fontSize,
        fontWeight: 500,
        lineHeight: '17px',
        letterSpacing: typography.textSmall.letterSpacing
      },
      column: {
        fontFamily: typography.textSmall.fontFamily,
        fontSize: typography.textSmall.fontSize,
        fontWeight: typography.textSmall.fontWeight,
        lineHeight: '16px',
        letterSpacing: typography.textSmall.letterSpacing,
        padding: '16px'
      },
      row: {
        height: '48px'
      }
    },
    label: {
      fontSize: typography.textSmall.fontSize,
      fontFamily: typography.textSmall.fontFamily,
      fontWeight: typography.textSmall.fontWeight,
      lineHeight: typography.textSmall.lineHeight,
      letterSpacing: typography.textSmall.letterSpacing
    },
    stepper: {
      height: '48px',
      fontFamily: typography.textSmall.fontFamily,
      fontSize: typography.textSmall.fontSize,
      lineHeight: typography.textSmall.lineHeight,
      fontWeight: typography.textSmall.fontWeight,
      chevronIconWidth: '32px',
      chevronIconHeight: '32px',
      border: '2px solid transparent',
      borderHover: `2px solid ${colors.coreColors.blue}`,
      borderSelected: `2px solid ${colors.coreColors.blue}`,
      itemPadding: '8px 0px 12px 0px',
      itemPaddingSelected: '8px 0px 12px 0px',
      successIconHeight: '18px',
      successIconWidth: '18px',
      stepIndicator: {
        width: '24px',
        height: '24px',
        borderRadius: '50%',
        fontFamily: typography.textSmall.fontFamily,
        fontSize: typography.textSmall.fontSize,
        lineHeight: typography.textSmall.lineHeight,
        fontWeight: 500
      }
    },
    badge: {
      badgeHeight: '16px',
      badgeWidth: '16px',
      badgeHeightDot: '8px',
      badgeWidthDot: '8px',
      fontSize: '12px',
      fontFamily: typography.textSmall.fontFamily,
      fontWeight: typography.textSmall.fontWeight,
      lineHeight: '16px'
    },
    textTag: {
      height: '24px',
      minWidth: '16px',
      borderRadius: '4px',
      padding: '0px 8px',
      fontSize: '12px',
      fontFamily: typography.textSmall.fontFamily,
      fontWeight: '500',
      lineHeight: '24px'
    },
    progressBar: {
      fontFamily: typography.textDefault.fontFamily,
      fontSize: typography.textDefault.fontSize,
      lineHeight: typography.textDefault.lineHeight,
      fontWeight: typography.textDefault.fontWeight
    },
    slider: {
      fontFamily: typography.textSmall.fontFamily,
      fontSize: typography.textSmall.fontSize,
      lineHeight: typography.textSmall.lineHeight,
      fontWeight: typography.textSmall.fontWeight
    },
    contentSwitcher: {
      borderRadius: '0px',
      itemHeight: '28px',
      innerPadding: '4px 28px',
      fontFamily: typography.textSmall.fontFamily,
      fontSize: typography.textSmall.fontSize,
      fontWeight: typography.textSmall.fontWeight,
      letterSpacing: 'normal',
      lineHeight: typography.textSmall.lineHeight
    },
    chip: {
      padding: '5px 12px',
      borderRadius: '4px',
      fontSize: typography.textSmall.fontSize,
      fontWeight: typography.textSmall.fontWeight,
      letterSpacing: typography.textSmall.letterSpacing,
      lineHeight: typography.textSmall.lineHeight,
      fontFamily: typography.textSmall.fontFamily
    },
    iconButton: {
      padding: '8px',
      borderRadius: '50%',
      iconWidth: '24px',
      iconHeight: '24px',
      tabIconOffset: '-5px'
    },
    colors: {
      palette: colors,
      common: {
        outlineColor: 'transparent',
        outlineLinkColor: colors.neutral.black,
        disabledColor: colors.neutral.neutral30
      },
      appFrame: {
        shimmer: {
          placeholder: {
            header: {
              bg: colors.neutral.neutral10,
              tint: colors.neutral.neutral5
            },
            menu: {
              bg: colors.neutral.neutral10,
              tint: colors.neutral.neutral5
            }
          }
        },
        bellWidget: {
          headerBg: colors.neutral.white,
          headerBorderColor: colors.neutral.neutral10,
          headerTextColor: colors.neutral.black,
          contentBg: colors.neutral.white,
          itemDate: 'rgba(53, 65, 74, 0.5)',
          itemBorder: colors.neutral.neutral10,
          itemHoverBg: colors.neutral.neutral5,
          itemUnreadBg: colors.neutral.neutral5,
          loaderColor: colors.neutral.neutral80,
          footerTextColor: colors.coreColors.blue,
          placeholderColor: colors.neutral.black
        },
        header: {
          bg: colors.neutral.white,
          borderColor: colors.neutral.neutral20,
          menuToggler: 'rgba(254, 254, 254, 0.62)',
          icon: colors.neutral.white,
          iconNav: colors.neutral.black,
          iconNavHover: colors.neutral.black,
          iconNavDisabled: colors.neutral.neutral20,
          badge: colors.neutral.white,
          placeholder: colors.neutral.black,
          badgeBg: colors.coreColors.blue,
          searchBorder: colors.coreColors.deepBlue,
          searchPlaceholder: colors.neutral.black,
          searchPanelBg: colors.neutral.neutral5,
          searchPanelText: colors.neutral.black,
          searchPanelHover: colors.neutral.neutral5,
          menuTogglerBg: colors.neutral.neutral80,
          logoBorder: colors.coreColors.deepBlue,
          switcherHoverBg: colors.neutral.neutral5,
          switcherIconColor: colors.neutral.black,
          switcherDropdownBg: colors.neutral.white,
          switcherDropdownItemHoverBg: colors.neutral.neutral5,
          switcherActiveItemBorderColor: colors.dataVisualization.electricBlue.electricBlue600,
          switcherLinkColor: colors.neutral.black,
          switcherLinkHoverColor: colors.dataVisualization.electricBlue.electricBlue600,
          moduleIconColor: colors.neutral.black
        },
        menu: {
          toggler: 'rgba(254, 254, 254, 0.62)',
          line: 'rgba(169, 190, 215, 0.3)',
          bg: colors.neutral.white,
          headerBg: colors.miscellaneousColors.miscellaneousColors1,
          borderColor: colors.neutral.neutral10,
          headerText: colors.neutral.white,
          badgeBg: colors.miscellaneousColors.miscellaneousColors2,
          delimiter: 'rgba(255, 255, 255, 0.6)',
          tooltipText: colors.neutral.white,
          tooltipBg: colors.miscellaneousColors.miscellaneousColors3,
          itemIconColor: colors.dataVisualization.electricBlue.electricBlue600,
          itemText: colors.neutral.neutral80,
          itemTextHover: colors.neutral.neutral80,
          itemActiveBadge: colors.dataVisualization.electricBlue.electricBlue600,
          itemHoverBg: colors.neutral.neutral5,
          itemActiveBg: colors.neutral.neutral10,
          itemArrowIndicator: colors.neutral.black,
          itemArrowAreaBorder: colors.neutral.neutral5,
          groupBg: colors.neutral.white,
          groupHoverBg: colors.neutral.neutral5,
          groupSeparator: 'rgba(170, 191, 216, 0.3)',
          placeholderBgColor: colors.miscellaneousColors.miscellaneousColors4,
          placeholderTintColor: colors.miscellaneousColors.miscellaneousColors5,
          submenuDivider: colors.dataVisualization.deepBlue.deepBlue200,
          submenuSectionTitleColor: colors.neutral.neutral54,
          switcherBg: colors.miscellaneousColors.miscellaneousColors6,
          switcherHoverBg: colors.miscellaneousColors.miscellaneousColors7,
          switcherText: colors.neutral.white,
          switcherHeaderTextColor: colors.neutral.white,
          switcherLine: 'rgba(170, 191, 216, 0.3)',
          switcherShadow: 'rgba(0, 0, 0, 0.15)',
          switcherTogglerColor: colors.neutral.white
        },
        snack: {
          bgColor: colors.neutral.white,
          closeBtn: colors.neutral.neutral54,
          closeBtnHover: colors.neutral.black,
          readBtn: colors.dataVisualization.electricBlue.electricBlue600,
          readBtnHover: colors.dataVisualization.electricBlue.electricBlue600,
          text: colors.neutral.black,
          background: colors.neutral.white,
          link: colors.neutral.neutral80,
          linkHover: colors.neutral.neutral80,
          categories: {
            critical: colors.feedback.solid.danger,
            error: colors.feedback.solid.danger,
            warning: colors.feedback.solid.warning,
            success: colors.feedback.solid.success,
            info: colors.feedback.solid.informational,
            default: colors.neutral.black
          }
        },
        breadcrumbs: {
          containerBg: colors.neutral.white,
          color: colors.neutral.neutral80,
          linkColor: colors.neutral.neutral54,
          hoverColor: colors.coreColors.blue,
          separator: colors.neutral.neutral54,
          popoverBg: colors.neutral.white,
          popoverItemColor: colors.coreColors.blue,
          popoverItemLinkColor: colors.neutral.neutral54,
          popoverItemBorder: colors.neutral.white,
          popoverItemHover: colors.neutral.neutral5,
          popoverItemTextHover: colors.coreColors.blue
        }
      },
      button: {
        textColor: colors.neutral.white,
        disabledTextColor: colors.neutral.neutral54,
        disabledBgColor: colors.neutral.neutral20,
        disabledSubBorderColor: colors.neutral.neutral54,
        primary: {
          textColor: colors.neutral.white,
          linkColor: colors.neutral.black,
          linkHoverColor: colors.coreColors.blue,
          bgColor: colors.coreColors.blue,
          hoverBgColor: colors.dataVisualization.electricBlue.electricBlue600,
          activeBgColor: colors.dataVisualization.electricBlue.electricBlue700,
          disabledTextColor: colors.neutral.neutral54,
          disabledBgColor: colors.neutral.neutral20,
          disabledBorder: '1px solid #ccc',
          subBorderColor: colors.neutral.white,
          linkArrowColor: colors.coreColors.blue,
          dark: {
            textColor: colors.coreColors.deepBlue,
            bgColor: colors.coreColors.cyan,
            hoverBgColor: colors.coreColors.lightBlue,
            activeBgColor: colors.coreColors.superLightBlue,
            linkColor: colors.neutral.white,
            linkHoverColor: colors.coreColors.cyan,
            linkArrowColor: colors.coreColors.cyan,
            linkActiveColor: colors.coreColors.cyan,
            disabledTextColor: colors.neutral.neutral54,
            disabledBgColor: colors.neutral.neutral20,
            disabledBorder: '1px solid #ccc',
            subBorderColor: colors.neutral.white
          }
        },
        secondary: {
          textColor: colors.coreColors.blue,
          linkColor: colors.neutral.neutral80,
          linkHoverColor: colors.coreColors.blue,
          bgColor: 'transparent',
          hoverBgColor: colors.miscellaneousColors.miscellaneousColors9,
          activeBgColor: colors.miscellaneousColors.miscellaneousColors11,
          border: '1px solid #2251ff',
          disabledTextColor: colors.neutral.neutral54,
          disabledBgColor: colors.neutral.neutral20,
          disabledBorder: '1px solid #ccc',
          subBorderColor: colors.coreColors.blue,
          linkArrowColor: colors.coreColors.blue,
          dark: {
            textColor: colors.neutral.white,
            bgColor: 'transparent',
            border: `1px solid ${colors.neutral.white}`,
            hoverBgColor: colors.miscellaneousColors.miscellaneousColors8,
            activeBgColor: colors.miscellaneousColors.miscellaneousColors8,
            linkColor: colors.neutral.neutral20,
            linkHoverColor: colors.coreColors.cyan,
            linkArrowColor: colors.coreColors.cyan,
            linkActiveColor: colors.coreColors.cyan,
            disabledTextColor: colors.neutral.neutral54,
            disabledBgColor: colors.neutral.neutral20,
            disabledBorder: '1px solid #ccc',
            subBorderColor: colors.coreColors.blue
          }
        },
        tertiary: {
          textColor: colors.neutral.neutral80,
          linkColor: colors.neutral.neutral80,
          linkHoverColor: colors.neutral.neutral80,
          bgColor: 'transparent',
          hoverBgColor: colors.miscellaneousColors.miscellaneousColors9,
          activeBgColor: colors.miscellaneousColors.miscellaneousColors11,
          border: '1px solid #cccccc',
          disabledTextColor: colors.neutral.neutral54,
          disabledBgColor: 'transparent',
          disabledBorder: '1px solid #ccc',
          subBorderColor: colors.neutral.neutral20,
          linkArrowColor: colors.neutral.neutral80,
          dark: {
            textColor: colors.neutral.neutral20,
            border: `1px solid ${colors.neutral.neutral54}`,
            hoverBorder: `1px solid ${colors.neutral.neutral20}`,
            activeBorder: `1px solid ${colors.neutral.neutral5}`,
            bgColor: 'transparent',
            activeBgColor: 'transparent',
            hoverBgColor: 'transparent',
            linkColor: colors.neutral.neutral54,
            linkHoverColor: colors.coreColors.cyan,
            linkArrowColor: colors.coreColors.cyan,
            linkActiveColor: colors.coreColors.cyan,
            disabledTextColor: colors.neutral.neutral54,
            disabledBgColor: 'transparent',
            disabledBorder: '1px solid #ccc',
            subBorderColor: colors.neutral.neutral20
          }
        },
        ghost: {
          textColor: colors.coreColors.blue,
          linkColor: colors.coreColors.blue,
          linkHoverColor: colors.coreColors.blue,
          bgColor: 'transparent',
          hoverBgColor: colors.miscellaneousColors.miscellaneousColors9,
          activeBgColor: colors.miscellaneousColors.miscellaneousColors11,
          border: '1px solid transparent',
          disabledTextColor: colors.neutral.neutral54,
          disabledBgColor: 'transparent',
          disabledBorder: 'none',
          subBorderColor: colors.coreColors.blue,
          linkArrowColor: colors.coreColors.blue,
          dark: {
            textColor: colors.neutral.white,
            bgColor: 'transparent',
            hoverBgColor: colors.miscellaneousColors.miscellaneousColors8,
            activeBgColor: colors.miscellaneousColors.miscellaneousColors8,
            linkColor: colors.coreColors.cyan,
            linkHoverColor: colors.coreColors.cyan,
            linkArrowColor: colors.coreColors.cyan,
            linkActiveColor: colors.coreColors.cyan,
            border: '1px solid transparent',
            disabledTextColor: colors.neutral.neutral54,
            disabledBgColor: 'transparent',
            disabledBorder: 'none',
            subBorderColor: colors.coreColors.blue
          }
        },
        danger: {
          textColor: colors.neutral.white,
          linkColor: colors.feedback.solid.danger,
          linkHoverColor: colors.feedback.solid.danger,
          bgColor: colors.feedback.solid.danger,
          hoverBgColor: colors.dataVisualization.crimsonRed.crimsonRed600,
          activeBgColor: colors.dataVisualization.crimsonRed.crimsonRed900,
          subBorderColor: colors.neutral.white,
          linkArrowColor: colors.feedback.solid.danger,
          dark: {
            textColor: colors.neutral.white,
            bgColor: colors.neutral.midRed,
            hoverBgColor: colors.neutral.darkRed,
            activeBgColor: colors.neutral.superDarkRed,
            linkColor: colors.neutral.midRed,
            linkHoverColor: colors.coreColors.midRed,
            linkArrowColor: colors.coreColors.midRed,
            linkActiveColor: colors.coreColors.midRed,
            subBorderColor: colors.neutral.white
          }
        }
      },
      buttonGroup: {
        contextMenu: {
          shadow: elevation.sm,
          textColor: colors.neutral.black,
          trigger: {
            bg: colors.neutral.white,
            hoverBg: colors.miscellaneousColors.miscellaneousColors9,
            borderColor: colors.coreColors.blue,
            icon: colors.coreColors.blue
          },
          item: {
            text: colors.neutral.white,
            bg: colors.neutral.white,
            hoverBg: colors.neutral.neutral5,
            border: colors.neutral.white
          }
        }
      },
      typography: {
        text: colors.neutral.neutral80
      },
      card: {
        containerBg: colors.neutral.white,
        titleColor: colors.dataVisualization.electricBlue.electricBlue600,
        descriptionColor: colors.neutral.neutral30,
        iconColor: colors.coreColors.blue
      },
      splash: {
        background: colors.neutral.white
      },
      verticalTabs: {
        text: colors.coreColors.blue,
        textInactive: colors.neutral.neutral80,
        headerText: colors.neutral.neutral30,
        headerShadow: colors.miscellaneousColors.miscellaneousColors10,
        hoverBg: 'rgba(0, 0, 0, 0)',
        hoverText: colors.neutral.black,
        activeBg: colors.neutral.neutral5,
        activeBorder: colors.coreColors.blue
      },
      accordion: {
        headerBg: colors.neutral.white,
        headerActiveBg: colors.neutral.white,
        headerHoverBg: colors.neutral.neutral5,
        borderColor: colors.neutral.neutral20,
        iconColor: colors.neutral.neutral70,
        iconHoverColor: colors.neutral.neutral70,
        iconActiveColor: colors.neutral.neutral70,
        labelColor: colors.neutral.neutral80,
        labelHoverColor: colors.neutral.neutral80,
        labelActiveColor: colors.neutral.neutral80
      },
      panel: {
        headerBg: colors.coreColors.blue,
        headerText: colors.neutral.white,
        connectorBg: colors.neutral.neutral5,
        icon: colors.dataVisualization.deepBlue.deepBlue200,
        border: colors.neutral.neutral20,
        bodyShadow: elevation.sm
      },
      tabs: {
        text: colors.neutral.neutral80,
        primaryBg: colors.neutral.neutral5,
        primaryHoveredBg: 'rgba(255, 255, 255, 0.9)',
        primaryHoveredText: colors.dataVisualization.electricBlue.electricBlue600,
        primaryTabBg: colors.neutral.white,
        primaryActiveBg: colors.neutral.white,
        primaryActiveText: colors.dataVisualization.electricBlue.electricBlue600,
        secondaryBg: colors.neutral.white,
        secondaryText: colors.neutral.neutral80,
        secondaryActiveText: colors.dataVisualization.electricBlue.electricBlue600,
        secondaryShadow: colors.neutral.neutral10,
        badgeBg: colors.coreColors.blue,
        badgeText: colors.neutral.white,
        secondaryBadgeBg: colors.neutral.neutral20,
        secondaryBadgeText: colors.neutral.white
      },
      loadingIndicator: {
        overlayBg: 'rgba(255, 255, 255, 0.9)',
        externalBg: 'rgba(255, 255, 255, 0.1)',
        circleBg: colors.neutral.neutral5,
        bg: colors.coreColors.blue,
        startColor: colors.coreColors.blue,
        stopColor: colors.coreColors.cyan
      },
      unsupportedBrowser: {
        bg: colors.neutral.white
      },
      forbidden: {
        bg: colors.neutral.neutral5,
        mainTextColor: colors.neutral.black,
        secondaryTextColor: colors.neutral.neutral70
      },
      pageNotFound: {
        bg: colors.neutral.neutral5
      },
      toast: {
        infoButtonText: colors.neutral.white,
        infoText: colors.neutral.white,
        infoBg: colors.coreColors.blue,
        actionsInfoBg: 'transparent',
        actionsInfoBgHover: 'rgba(255, 255, 255, 0.1)',
        actionsInfoBgActive: 'rgba(255, 255, 255, 0.2)',
        errorButtonText: colors.neutral.white,
        errorText: colors.neutral.white,
        errorBg: colors.feedback.solid.danger,
        actionsErrorBg: colors.feedback.solid.danger,
        dangerButtonText: colors.neutral.white,
        dangerText: colors.neutral.white,
        dangerBg: colors.feedback.solid.danger,
        actionsDangerBg: 'transparent',
        actionsDangerBgHover: 'rgba(255, 255, 255, 0.1)',
        actionsDangerBgActive: 'rgba(255, 255, 255, 0.2)',
        warnButtonText: colors.feedback.solid.neutral,
        warnText: colors.feedback.solid.neutral,
        warnBg: colors.feedback.solid.warning,
        actionsWarnBg: 'transparent',
        actionsWarnBgHover: 'rgba(0, 0, 0, 0.1)',
        actionsWarnBgActive: 'rgba(0, 0, 0, 0.2)',
        successButtonText: colors.neutral.white,
        successText: colors.neutral.white,
        successBg: colors.feedback.solid.success,
        actionsSuccessBg: 'transparent',
        actionsSuccessBgHover: 'rgba(255, 255, 255, 0.1)',
        actionsSuccessBgActive: 'rgba(255, 255, 255, 0.2)',
        neutralButtonText: colors.neutral.white,
        neutralText: colors.neutral.white,
        neutralBg: colors.feedback.solid.neutral,
        actionsNeutralBg: 'transparent',
        actionsNeutralBgHover: 'rgba(255, 255, 255, 0.1)',
        actionsNeutralBgActive: 'rgba(255, 255, 255, 0.2)',
        warnIcon: colors.feedback.solid.neutral,
        warnIconHover: colors.neutral.black,
        errorIcon: colors.neutral.white,
        dangerIcon: colors.neutral.neutral10,
        dangerIconHover: colors.neutral.white,
        infoIcon: colors.neutral.neutral10,
        infoIconHover: colors.neutral.white,
        neutralIcon: colors.neutral.neutral10,
        neutralIconHover: colors.neutral.white,
        successIcon: colors.neutral.neutral10,
        successIconHover: colors.neutral.white,
        primaryBtn: {
          infoText: colors.coreColors.blue,
          infoBg: colors.neutral.white,
          infoBgHover: colors.miscellaneousColors.miscellaneousColors9,
          infoBgActive: colors.miscellaneousColors.miscellaneousColors11,
          dangerText: colors.feedback.solid.danger,
          dangerBg: colors.neutral.white,
          dangerBgHover: colors.feedback.light.dangerLight,
          dangerBgActive: '#fccfcf',
          warnText: colors.neutral.white,
          warnBg: colors.neutral.black,
          warnBgHover: colors.feedback.solid.neutral,
          warnBgActive: colors.neutral.neutral70,
          successText: colors.feedback.solid.success,
          successBg: colors.neutral.white,
          successBgHover: '#e5f2e9',
          successBgActive: '#cce6d4',
          neutralText: colors.feedback.solid.neutral,
          neutralBg: colors.neutral.white,
          neutralBgHover: colors.neutral.neutral10,
          neutralBgActive: colors.neutral.neutral20,
          errorText: colors.feedback.solid.danger,
          errorBg: colors.neutral.white
        }
      },
      table: {
        text: colors.neutral.neutral80,
        headerBg: colors.neutral.neutral10,
        selection: colors.miscellaneousColors.miscellaneousColors13,
        rowBorder: colors.neutral.neutral20,
        columnBorder: colors.neutral.neutral10,
        selectedBg: colors.miscellaneousColors.miscellaneousColors14,
        nthChild: colors.neutral.neutral5
      },
      contextMenu: {
        itemText: colors.neutral.neutral80,
        hoverItemText: colors.neutral.black,
        divider: colors.neutral.neutral5,
        hoverBg: colors.neutral.neutral5,
        icon: colors.dataVisualization.deepBlue.deepBlue400,
        bg: colors.neutral.white,
        arrowIndicatorColor: colors.neutral.black,
        togglerBg: colors.neutral.neutral10,
        customIconsColor: colors.neutral.black,
        boxShadow: elevation.rg,
        itemTextDisabled: colors.neutral.neutral20,
        iconDisabled: colors.neutral.neutral20
      },
      splitter: {
        icon: colors.coreColors.blue,
        bg: colors.neutral.neutral10,
        hoverBg: colors.neutral.neutral10,
        activeBg: colors.neutral.neutral10,
        indicatorBg: colors.neutral.white,
        indicatorBorder: colors.neutral.neutral10
      },
      contentPlaceholder: {
        bgColor: colors.neutral.neutral5,
        gradientTint: colors.neutral.neutral5
      },
      filterLayout: {
        label: colors.neutral.neutral80,
        badgeBg: colors.coreColors.blue,
        bg: colors.neutral.white,
        border: 'rgba(255, 255, 255, 0.5)',
        text: colors.miscellaneousColors.miscellaneousColors15,
        checkboxText: colors.miscellaneousColors.miscellaneousColors15,
        radioText: colors.miscellaneousColors.miscellaneousColors15
      },
      tooltip: {
        shadow: '0px 4px 8px -1px rgba(5, 28, 44, 0.2),0px 0px 1px 0px rgba(5, 28, 44, 0.15)',
        default: colors.neutral.neutral80,
        defaultText: colors.neutral.white,
        error: colors.feedback.solid.danger,
        errorText: colors.neutral.white,
        warning: colors.feedback.solid.warning,
        warningText: colors.neutral.white,
        info: colors.feedback.solid.success,
        infoText: colors.neutral.white
      },
      label: {
        text: colors.neutral.white,
        shadow: 'rgba(34, 34, 34, 0.2)',
        bg: colors.dataVisualization.electricBlue.electricBlue600
      },
      modal: {
        bg: colors.neutral.white,
        icon: colors.neutral.black,
        iconHover: colors.neutral.neutral80,
        shadow: elevation.xl,
        headerText: colors.neutral.black,
        headerBg: 'transparent',
        headerBorder: 'transparent'
      },
      inlineDropdown: {
        inputBg: colors.neutral.white,
        text: colors.neutral.neutral80,
        label: colors.coreColors.blue,
        bg: colors.neutral.white,
        disableText: colors.neutral.neutral20,
        hoverBg: colors.neutral.neutral5,
        hoverTextColor: colors.neutral.black,
        icon: colors.neutral.neutral80
      },
      checkbox: {
        light: {
          textColor: colors.neutral.neutral80,
          borderColor: colors.neutral.neutral20,
          bgColor: colors.neutral.white,
          hoverBgColor: colors.neutral.white,
          hoverBorderColor: colors.coreColors.blue,
          checkedBgColor: colors.coreColors.blue,
          checkedBorderColor: colors.coreColors.blue,
          checkedHoverBgColor: colors.coreColors.blue,
          checkedHoverBorderColor: colors.coreColors.blue,
          checkBorderColor: colors.neutral.white,
          disabledBorderColor: colors.neutral.neutral20,
          disabledBgColor: colors.neutral.neutral20,
          disabledCheckBorderColor: colors.neutral.white,
          disabledTextColor: colors.neutral.neutral30,
          disabledCheckedBorderColor: colors.miscellaneousColors.miscellaneousColors16,
          disabledCheckedBgColor: colors.miscellaneousColors.miscellaneousColors16,
          asteriskColor: colors.feedback.solid.danger,
          asteriskDisabledColor: colors.miscellaneousColors.miscellaneousColors17,
          errorMessageColor: colors.feedback.solid.danger,
          groupLabelColor: colors.neutral.neutral80,
          errorTextColor: colors.feedback.solid.danger,
          errorBgColor: colors.neutral.white,
          errorBorderColor: colors.feedback.solid.danger,
          disabledCheckedErrorBgColor: colors.dataVisualization.crimsonRed.crimsonRed200,
          disabledCheckedErrorBorderColor: colors.dataVisualization.crimsonRed.crimsonRed200,
          checkedErrorBgColor: colors.feedback.solid.danger,
          checkedErrorBorderColor: colors.feedback.solid.danger
        },
        medium: {
          textColor: colors.neutral.neutral80,
          borderColor: colors.neutral.neutral20,
          bgColor: colors.neutral.white,
          hoverBgColor: colors.neutral.white,
          hoverBorderColor: colors.coreColors.blue,
          checkedBgColor: colors.coreColors.blue,
          checkedBorderColor: colors.coreColors.blue,
          checkedHoverBgColor: colors.coreColors.blue,
          checkedHoverBorderColor: colors.coreColors.blue,
          checkBorderColor: colors.neutral.white,
          disabledBorderColor: colors.neutral.neutral20,
          disabledBgColor: colors.neutral.neutral20,
          disabledCheckBorderColor: colors.neutral.white,
          disabledTextColor: colors.neutral.neutral30,
          disabledCheckedBorderColor: colors.miscellaneousColors.miscellaneousColors16,
          disabledCheckedBgColor: colors.miscellaneousColors.miscellaneousColors16,
          asteriskColor: colors.feedback.solid.danger,
          asteriskDisabledColor: colors.miscellaneousColors.miscellaneousColors17,
          errorMessageColor: colors.feedback.solid.danger,
          groupLabelColor: colors.neutral.neutral80,
          errorTextColor: colors.feedback.solid.danger,
          errorBgColor: colors.feedback.solid.danger,
          errorBorderColor: colors.feedback.solid.danger,
          disabledCheckedErrorBgColor: colors.dataVisualization.crimsonRed.crimsonRed200,
          disabledCheckedErrorBorderColor: colors.dataVisualization.crimsonRed.crimsonRed200,
          checkedErrorBgColor: colors.feedback.solid.danger,
          checkedErrorBorderColor: colors.feedback.solid.danger
        },
        dark: {
          textColor: colors.neutral.neutral80,
          borderColor: colors.neutral.neutral20,
          bgColor: colors.neutral.white,
          hoverBgColor: colors.neutral.white,
          hoverBorderColor: colors.coreColors.blue,
          checkedBgColor: colors.coreColors.blue,
          checkedBorderColor: colors.coreColors.blue,
          checkedHoverBgColor: colors.coreColors.blue,
          checkedHoverBorderColor: colors.coreColors.blue,
          checkBorderColor: colors.neutral.white,
          disabledBorderColor: colors.neutral.neutral20,
          disabledBgColor: colors.neutral.neutral20,
          disabledCheckBorderColor: colors.neutral.white,
          disabledTextColor: colors.neutral.neutral30,
          disabledCheckedBorderColor: colors.miscellaneousColors.miscellaneousColors16,
          disabledCheckedBgColor: colors.miscellaneousColors.miscellaneousColors16,
          asteriskColor: colors.feedback.solid.danger,
          asteriskDisabledColor: colors.miscellaneousColors.miscellaneousColors17,
          errorMessageColor: colors.feedback.solid.danger,
          groupLabelColor: colors.neutral.neutral80,
          errorTextColor: colors.feedback.solid.danger,
          errorBgColor: colors.feedback.solid.danger,
          errorBorderColor: colors.feedback.solid.danger,
          disabledCheckedErrorBgColor: colors.dataVisualization.crimsonRed.crimsonRed200,
          disabledCheckedErrorBorderColor: colors.dataVisualization.crimsonRed.crimsonRed200,
          checkedErrorBgColor: colors.feedback.solid.danger,
          checkedErrorBorderColor: colors.feedback.solid.danger
        }
      },
      tagsInput: {
        tagLabel: colors.neutral.neutral80,
        disabledTagLabel: colors.neutral.neutral80,
        description: colors.neutral.neutral80,
        tagBg: colors.neutral.neutral10,
        tagHoverBg: colors.neutral.neutral20,
        tagRemoveButtonBg: colors.neutral.neutral10,
        tagRemoveButtonHoverBg: colors.neutral.neutral20,
        tagRemoveButtonColor: colors.neutral.neutral70,
        tagRemoveButtonHoverColor: colors.neutral.neutral80,
        tagInvalidStateBg: colors.feedback.solid.danger,
        tagInvalidStateHoverBg: colors.dataVisualization.crimsonRed.crimsonRed600,
        tagInvalidStateRemoveButtonBg: colors.feedback.solid.danger,
        tagInvalidStateRemoveButtonHoverBg: colors.dataVisualization.crimsonRed.crimsonRed600,
        tagInvalidStateLabelColor: colors.neutral.white,
        tagInvalidStateRemoveButtonColor: colors.neutral.white,
        bg: colors.neutral.white,
        bgHover: colors.neutral.white,
        border: colors.neutral.neutral20,
        borderHover: colors.neutral.neutral20,
        disabledBorder: colors.neutral.neutral20,
        focusBg: colors.neutral.white,
        focusBorder: colors.coreColors.blue,
        asteriskColor: colors.feedback.solid.danger,
        errorMessageColor: colors.feedback.solid.danger,
        errorStateBg: colors.neutral.white,
        errorStateBorder: colors.feedback.solid.danger,
        focusErrorBorder: colors.feedback.solid.danger,
        labelColor: colors.neutral.neutral80,
        disabledLabelColor: colors.neutral.neutral80,
        disabledBg: colors.neutral.neutral5,
        disabledTagBg: colors.neutral.neutral20,
        disabledTagRemoveButtonBg: colors.neutral.neutral20,
        disabledTagRemoveButtonColor: colors.neutral.neutral54,
        disabledLabel: colors.neutral.neutral54,
        disabledDescription: colors.neutral.neutral20,
        placeholder: colors.neutral.neutral20,
        placeholderHover: colors.neutral.neutral20,
        placeholderFocus: colors.neutral.neutral54,
        placeholderError: colors.feedback.solid.danger
      },
      switch: {
        light: {
          bulb: colors.neutral.white,
          disabledOffBulb: colors.neutral.neutral20,
          disabledOnBulb: colors.neutral.white,
          onBg: colors.coreColors.blue,
          offBg: colors.neutral.neutral20,
          onDisabledBg: colors.miscellaneousColors.miscellaneousColors16,
          offDisabledBg: colors.neutral.neutral10,
          disabledText: colors.neutral.neutral30,
          text: colors.neutral.neutral80,
          titleColor: colors.neutral.neutral80,
          asteriskColor: colors.feedback.solid.danger,
          errorMessageColor: colors.feedback.solid.danger
        },
        medium: {
          bulb: colors.neutral.white,
          disabledOffBulb: colors.neutral.neutral20,
          disabledOnBulb: colors.neutral.white,
          onBg: colors.coreColors.blue,
          offBg: colors.neutral.neutral20,
          onDisabledBg: colors.miscellaneousColors.miscellaneousColors16,
          offDisabledBg: colors.neutral.neutral10,
          disabledText: colors.neutral.neutral30,
          text: colors.neutral.neutral80,
          titleColor: colors.neutral.neutral80,
          asteriskColor: colors.feedback.solid.danger,
          errorMessageColor: colors.feedback.solid.danger
        },
        dark: {
          bulb: colors.neutral.white,
          disabledOffBulb: colors.neutral.neutral20,
          disabledOnBulb: colors.neutral.white,
          onBg: colors.coreColors.blue,
          offBg: colors.neutral.neutral20,
          onDisabledBg: colors.miscellaneousColors.miscellaneousColors16,
          offDisabledBg: colors.neutral.neutral10,
          disabledText: colors.neutral.neutral30,
          text: colors.neutral.neutral80,
          titleColor: colors.neutral.neutral80,
          asteriskColor: colors.feedback.solid.danger,
          errorMessageColor: colors.feedback.solid.danger
        }
      },
      radio: {
        light: {
          bg: colors.neutral.white,
          borderColor: colors.neutral.neutral20,
          hoverBg: colors.neutral.white,
          hoverBorder: colors.coreColors.blue,
          checkedBg: colors.neutral.white,
          text: colors.neutral.neutral80,
          checkedBorder: colors.coreColors.blue,
          disabledBg: colors.neutral.neutral20,
          disabledBorder: colors.neutral.neutral20,
          disabledText: 'rgba(0, 0, 0, 0.26)',
          disabledCheckedBg: colors.neutral.white,
          disabledCheckedBorder: colors.miscellaneousColors.miscellaneousColors16,
          disabledCheckedCircleBg: colors.miscellaneousColors.miscellaneousColors16,
          groupLabelColor: colors.neutral.neutral80,
          groupErrorMessageColor: colors.feedback.solid.danger,
          groupAsteriskColor: colors.feedback.solid.danger
        },
        medium: {
          bg: colors.neutral.white,
          borderColor: colors.neutral.neutral20,
          hoverBg: colors.neutral.white,
          hoverBorder: colors.coreColors.blue,
          checkedBg: colors.neutral.white,
          text: colors.neutral.neutral80,
          checkedBorder: colors.coreColors.blue,
          disabledBg: colors.neutral.neutral20,
          disabledBorder: colors.neutral.neutral20,
          disabledText: 'rgba(0, 0, 0, 0.26)',
          disabledCheckedBg: colors.neutral.white,
          disabledCheckedBorder: colors.miscellaneousColors.miscellaneousColors16,
          disabledCheckedCircleBg: colors.miscellaneousColors.miscellaneousColors16,
          groupLabelColor: colors.neutral.neutral80,
          groupErrorMessageColor: colors.feedback.solid.danger,
          groupAsteriskColor: colors.feedback.solid.danger
        },
        dark: {
          bg: colors.neutral.white,
          borderColor: colors.neutral.neutral20,
          hoverBg: colors.neutral.white,
          hoverBorder: colors.coreColors.blue,
          checkedBg: colors.neutral.white,
          text: colors.neutral.neutral80,
          checkedBorder: colors.coreColors.blue,
          disabledBg: colors.neutral.neutral,
          disabledBorder: colors.neutral.neutral20,
          disabledText: 'rgba(0, 0, 0, 0.26)',
          disabledCheckedBg: colors.neutral.white,
          disabledCheckedBorder: colors.miscellaneousColors.miscellaneousColors16,
          disabledCheckedCircleBg: colors.miscellaneousColors.miscellaneousColors16,
          groupLabelColor: colors.neutral.neutral80,
          groupErrorMessageColor: colors.feedback.solid.danger,
          groupAsteriskColor: colors.feedback.solid.danger
        }
      },
      dropdown: {
        light: {
          text: colors.neutral.neutral80,
          focusText: colors.neutral.neutral80,
          label: colors.neutral.neutral80,
          bg: colors.neutral.white,
          border: colors.neutral.neutral20,
          focusBg: colors.neutral.white,
          hoverBg: colors.neutral.neutral5,
          optionsBg: colors.neutral.white,
          hoverOptionColor: colors.neutral.black,
          hoverOptionIconColor: colors.neutral.black,
          focusInput: colors.coreColors.blue,
          disableText: colors.neutral.neutral30,
          disableBg: colors.neutral.neutral10,
          disableBorder: colors.neutral.neutral20,
          disabledLabel: colors.neutral.neutral20,
          disabledDescription: colors.neutral.neutral20,
          multiBg: colors.neutral.neutral80,
          multiHoverBg: colors.neutral.neutral54,
          multiTextColor: colors.neutral.white,
          multiRemoveIcon: colors.neutral.white,
          multiRemoveIconHover: colors.neutral.white,
          disableMultiBg: colors.neutral.neutral10,
          selectedIcon: colors.neutral.black,
          asterisk: colors.feedback.solid.danger,
          disabledAsterisk: 'rgba(255, 0, 0, 0.2)',
          errorMessageColor: colors.feedback.solid.danger,
          errorStateBg: colors.neutral.white,
          errorBorderColor: colors.feedback.solid.danger,
          focusErrorBorderColor: colors.feedback.solid.danger,
          placeholder: colors.neutral.neutral20,
          description: colors.neutral.neutral80,
          iconColor: colors.neutral.neutral80,
          iconFocusColor: colors.neutral.neutral80,
          iconDisabledColor: colors.neutral.neutral20,
          iconErrorColor: colors.feedback.solid.danger,
          customOptionIcon: colors.neutral.black
        },
        medium: {
          text: colors.neutral.neutral80,
          focusText: colors.neutral.neutral80,
          label: colors.neutral.neutral80,
          bg: colors.neutral.white,
          border: colors.neutral.neutral20,
          focusBg: colors.neutral.white,
          hoverBg: colors.neutral.neutral5,
          optionsBg: colors.neutral.white,
          hoverOptionColor: colors.neutral.black,
          hoverOptionIconColor: colors.neutral.black,
          focusInput: colors.coreColors.blue,
          disableText: colors.neutral.neutral30,
          disableBg: colors.neutral.neutral10,
          disableBorder: colors.neutral.neutral20,
          disabledLabel: colors.neutral.neutral20,
          disabledDescription: colors.neutral.neutral20,
          multiBg: colors.neutral.neutral80,
          multiHoverBg: colors.neutral.neutral54,
          multiTextColor: colors.neutral.white,
          multiRemoveIcon: colors.neutral.white,
          multiRemoveIconHover: colors.neutral.white,
          disableMultiBg: colors.neutral.neutral10,
          selectedIcon: colors.neutral.black,
          asterisk: colors.feedback.solid.danger,
          disabledAsterisk: 'rgba(255, 0, 0, 0.2)',
          errorMessageColor: colors.feedback.solid.danger,
          errorStateBg: colors.neutral.white,
          errorBorderColor: colors.feedback.solid.danger,
          focusErrorBorderColor: colors.feedback.solid.danger,
          placeholder: colors.neutral.neutral20,
          description: colors.neutral.neutral80,
          iconColor: colors.neutral.neutral80,
          iconFocusColor: colors.neutral.neutral80,
          iconDisabledColor: colors.neutral.neutral20,
          iconErrorColor: colors.feedback.solid.danger,
          customOptionIcon: colors.neutral.black
        },
        dark: {
          text: colors.neutral.neutral80,
          focusText: colors.neutral.neutral80,
          label: colors.neutral.neutral80,
          bg: colors.neutral.white,
          border: colors.neutral.neutral20,
          focusBg: colors.neutral.white,
          hoverBg: colors.neutral.neutral5,
          optionsBg: colors.neutral.white,
          hoverOptionColor: colors.neutral.black,
          hoverOptionIconColor: colors.neutral.black,
          focusInput: colors.coreColors.blue,
          disableText: colors.neutral.neutral30,
          disableBg: colors.neutral.neutral10,
          disableBorder: colors.neutral.neutral20,
          disabledLabel: colors.neutral.neutral20,
          disabledDescription: colors.neutral.neutral20,
          multiBg: colors.neutral.neutral80,
          multiHoverBg: colors.neutral.neutral54,
          multiTextColor: colors.neutral.white,
          multiRemoveIcon: colors.neutral.white,
          multiRemoveIconHover: colors.neutral.white,
          disableMultiBg: colors.neutral.neutral10,
          selectedIcon: colors.neutral.black,
          asterisk: colors.feedback.solid.danger,
          disabledAsterisk: 'rgba(255, 0, 0, 0.2)',
          errorMessageColor: colors.feedback.solid.danger,
          errorStateBg: colors.neutral.white,
          errorBorderColor: colors.feedback.solid.danger,
          focusErrorBorderColor: colors.feedback.solid.danger,
          placeholder: colors.neutral.neutral20,
          description: colors.neutral.neutral80,
          iconColor: colors.neutral.neutral80,
          iconFocusColor: colors.neutral.neutral80,
          iconDisabledColor: colors.neutral.neutral20,
          iconErrorColor: colors.feedback.solid.danger,
          customOptionIcon: colors.neutral.black
        }
      },
      textField: {
        light: {
          color: colors.neutral.neutral80,
          label: colors.neutral.neutral80,
          description: colors.neutral.neutral80,
          bg: colors.neutral.white,
          border: colors.neutral.neutral20,
          focusColor: colors.neutral.neutral80,
          focusBg: colors.neutral.white,
          focusBorder: colors.coreColors.blue,
          disabledBorder: colors.neutral.neutral20,
          disabledBg: colors.neutral.neutral10,
          disabledText: colors.neutral.neutral30,
          disabledLabel: colors.neutral.neutral20,
          disabledDescription: colors.neutral.neutral20,
          asterisk: colors.feedback.solid.danger,
          disabledAsterisk: 'rgba(255, 0, 0, 0.2)',
          checking: 'rgba(59, 115, 179, 0.4)',
          validBorder: colors.miscellaneousColors.miscellaneousColors12,
          errorBorder: colors.feedback.solid.danger,
          focusErrorBorder: colors.feedback.solid.danger,
          errorBg: colors.neutral.white,
          errorColor: colors.feedback.solid.danger,
          passwordIcon: colors.neutral.black,
          passwordDisabledIcon: colors.neutral.neutral20,
          placeholder: colors.neutral.neutral20,
          focusPlaceholder: colors.neutral.neutral20,
          iconColor: colors.neutral.neutral80,
          iconFocusColor: colors.neutral.neutral80,
          iconDisabledColor: colors.neutral.neutral20,
          iconErrorColor: colors.feedback.solid.danger
        },
        medium: {
          color: colors.neutral.neutral80,
          label: colors.neutral.neutral80,
          description: colors.neutral.neutral80,
          bg: colors.neutral.white,
          border: colors.neutral.neutral20,
          focusColor: colors.neutral.neutral80,
          focusBg: colors.neutral.white,
          focusBorder: colors.coreColors.blue,
          disabledBorder: colors.neutral.neutral20,
          disabledBg: colors.neutral.neutral10,
          disabledText: colors.neutral.neutral30,
          disabledLabel: colors.neutral.neutral20,
          disabledDescription: colors.neutral.neutral20,
          asterisk: colors.feedback.solid.danger,
          disabledAsterisk: 'rgba(255, 0, 0, 0.2)',
          checking: 'rgba(59, 115, 179, 0.4)',
          validBorder: colors.miscellaneousColors.miscellaneousColors12,
          errorBorder: colors.feedback.solid.danger,
          focusErrorBorder: colors.feedback.solid.danger,
          errorBg: colors.neutral.white,
          errorColor: colors.feedback.solid.danger,
          passwordIcon: colors.neutral.black,
          passwordDisabledIcon: colors.neutral.neutral20,
          placeholder: colors.neutral.neutral20,
          focusPlaceholder: colors.neutral.neutral20,
          iconColor: colors.neutral.neutral80,
          iconFocusColor: colors.neutral.neutral80,
          iconDisabledColor: colors.neutral.neutral20,
          iconErrorColor: colors.feedback.solid.danger
        },
        dark: {
          color: colors.neutral.neutral80,
          label: colors.neutral.neutral80,
          description: colors.neutral.neutral80,
          bg: colors.neutral.white,
          border: colors.neutral.neutral20,
          focusColor: colors.neutral.neutral80,
          focusBg: colors.neutral.white,
          focusBorder: colors.coreColors.blue,
          disabledBorder: colors.neutral.neutral20,
          disabledBg: colors.neutral.neutral10,
          disabledText: colors.neutral.neutral30,
          disabledLabel: colors.neutral.neutral20,
          disabledDescription: colors.neutral.neutral20,
          asterisk: colors.feedback.solid.danger,
          disabledAsterisk: 'rgba(255, 0, 0, 0.2)',
          checking: 'rgba(59, 115, 179, 0.4)',
          validBorder: colors.miscellaneousColors.miscellaneousColors12,
          errorBorder: colors.feedback.solid.danger,
          focusErrorBorder: colors.feedback.solid.danger,
          errorBg: colors.neutral.white,
          errorColor: colors.feedback.solid.danger,
          passwordIcon: colors.neutral.black,
          passwordDisabledIcon: colors.neutral.neutral20,
          placeholder: colors.neutral.neutral20,
          focusPlaceholder: colors.neutral.neutral20,
          iconColor: colors.neutral.neutral80,
          iconFocusColor: colors.neutral.neutral80,
          iconDisabledColor: colors.neutral.neutral20,
          iconErrorColor: colors.feedback.solid.danger
        }
      },
      numericInput: {
        light: {
          text: colors.neutral.neutral80,
          label: colors.neutral.neutral80,
          description: colors.neutral.neutral80,
          bg: colors.neutral.white,
          border: colors.neutral.neutral20,
          focusColor: colors.neutral.neutral80,
          focusBg: colors.neutral.white,
          focusBorder: colors.coreColors.blue,
          disabledBg: colors.neutral.neutral10,
          disabledText: colors.neutral.neutral30,
          disabledBorder: colors.neutral.neutral20,
          disabledLabel: colors.neutral.neutral20,
          disabledDescription: colors.neutral.neutral20,
          asteriskColor: colors.feedback.solid.danger,
          errorMessageColor: colors.feedback.solid.danger,
          errorBg: colors.neutral.white,
          errorBorder: colors.feedback.solid.danger,
          focusErrorBorder: colors.feedback.solid.danger,
          errorColor: colors.feedback.solid.danger,
          placeholder: colors.neutral.neutral20
        },
        medium: {
          text: colors.neutral.neutral80,
          label: colors.neutral.neutral80,
          description: colors.neutral.neutral80,
          bg: colors.neutral.white,
          border: colors.neutral.neutral20,
          focusColor: colors.neutral.neutral80,
          focusBg: colors.neutral.white,
          focusBorder: colors.coreColors.blue,
          disabledBg: colors.neutral.neutral10,
          disabledText: colors.neutral.neutral30,
          disabledBorder: colors.neutral.neutral20,
          disabledLabel: colors.neutral.neutral20,
          disabledDescription: colors.neutral.neutral20,
          asteriskColor: colors.feedback.solid.danger,
          errorMessageColor: colors.feedback.solid.danger,
          errorBg: colors.neutral.white,
          errorBorder: colors.feedback.solid.danger,
          focusErrorBorder: colors.feedback.solid.danger,
          errorColor: colors.feedback.solid.danger,
          placeholder: colors.neutral.neutral20
        },
        dark: {
          text: colors.neutral.neutral80,
          label: colors.neutral.neutral80,
          description: colors.neutral.neutral80,
          bg: colors.neutral.white,
          border: colors.neutral.neutral20,
          focusColor: colors.neutral.neutral80,
          focusBg: colors.neutral.white,
          focusBorder: colors.coreColors.blue,
          disabledBg: colors.neutral.neutral10,
          disabledText: colors.neutral.neutral30,
          disabledBorder: colors.neutral.neutral20,
          disabledLabel: colors.neutral.neutral20,
          disabledDescription: colors.neutral.neutral20,
          asteriskColor: colors.feedback.solid.danger,
          errorMessageColor: colors.feedback.solid.danger,
          errorBg: colors.neutral.white,
          errorBorder: colors.feedback.solid.danger,
          focusErrorBorder: colors.feedback.solid.danger,
          errorColor: colors.feedback.solid.danger,
          placeholder: colors.neutral.neutral20
        }
      },
      overlay: {
        bg: colors.coreColors.deepBlue,
        opacity: '0.85'
      },
      pagination: {
        text: colors.neutral.black,
        currentPageText: colors.neutral.neutral80,
        activeText: colors.coreColors.blue,
        pagerText: colors.neutral.black,
        pagerBg: colors.neutral.white,
        activeBagde: colors.coreColors.blue,
        line: colors.neutral.neutral,
        label: colors.neutral.neutral54,
        totalPagesLabel: colors.neutral.neutral70,
        action: colors.neutral.black,
        actionHover: colors.coreColors.blue,
        actionDisabled: colors.neutral.neutral20
      },
      calendar: {
        bg: colors.neutral.white,
        textColor: colors.neutral.black,
        textneutral20Color: colors.neutral.neutral20,
        border: colors.neutral.white,
        hoverBg: colors.neutral.white,
        hoverBorder: colors.neutral.black,
        activeBg: colors.coreColors.blue,
        activeTextColor: colors.neutral.white,
        activeBorder: colors.coreColors.blue,
        weekBorder: colors.miscellaneousColors.miscellaneousColors18,
        monthBg: colors.neutral.white,
        yearTextColor: colors.neutral.black,
        activeYear: colors.coreColors.blue,
        weekTextColor: colors.neutral.neutral54,
        titleColor: colors.neutral.neutral70,
        titleHoverColor: colors.neutral.black,
        titleHoverBg: colors.neutral.white,
        disabledColor: colors.neutral.neutral54,
        disabledBg: colors.neutral.white,
        disabledBorder: colors.neutral.white,
        disabledActiveColor: colors.neutral.neutral5,
        disabledActiveBg: colors.neutral.neutral20,
        disabledActiveBorder: colors.neutral.neutral20,
        controlsColor: colors.neutral.neutral70,
        controlsColorHover: colors.neutral.neutral80,
        boxShadow: elevation.rg
      },
      dateDropdown: {
        text: colors.neutral.neutral80,
        label: colors.neutral.neutral80,
        bg: colors.neutral.white,
        activeBg: colors.neutral.white,
        border: colors.neutral.neutral20,
        activeBorder: colors.coreColors.blue,
        disabledBg: colors.neutral.neutral10,
        disabledBorder: colors.neutral.neutral20,
        disabledLabel: colors.neutral.neutral20,
        disabledDescription: colors.neutral.neutral20,
        popoverBg: colors.neutral.white,
        closeIcon: colors.neutral.neutral30,
        asteriskColor: colors.feedback.solid.danger,
        errorMessage: colors.feedback.solid.danger,
        errorStateBg: colors.neutral.white,
        errorBorderColor: colors.feedback.solid.danger,
        focusErrorBorderColor: colors.feedback.solid.danger,
        placeholder: colors.neutral.neutral20,
        description: colors.neutral.neutral80,
        iconColor: colors.neutral.black,
        iconFocusColor: colors.neutral.black,
        iconDisabledColor: colors.neutral.neutral20,
        iconErrorColor: colors.feedback.solid.danger
      },
      datePicker: {
        background: colors.neutral.white,
        text: colors.neutral.black,
        active: colors.coreColors.blue,
        activeContrast: colors.neutral.white,
        selected: colors.neutral.neutral5,
        muted: colors.neutral.neutral20,
        disabled: colors.neutral.neutral20,
        navigation: colors.neutral.black,
        separator: colors.neutral.black
      },
      searchInput: {
        light: {
          bg: colors.neutral.white,
          border: colors.neutral.neutral20,
          focusBg: colors.neutral.white,
          focusBorder: colors.coreColors.blue,
          clearIcon: colors.neutral.neutral30,
          focusClearIcon: colors.neutral.neutral30,
          searchIcon: colors.neutral.black,
          focusSearchIcon: colors.neutral.black
        },
        medium: {
          bg: colors.neutral.white,
          border: colors.neutral.neutral20,
          focusBg: colors.neutral.white,
          focusBorder: colors.coreColors.blue,
          clearIcon: colors.neutral.neutral30,
          focusClearIcon: colors.neutral.neutral30,
          searchIcon: colors.neutral.black,
          focusSearchIcon: colors.neutral.black
        },
        dark: {
          bg: colors.neutral.white,
          border: colors.neutral.neutral20,
          focusBg: colors.neutral.white,
          focusBorder: colors.coreColors.blue,
          clearIcon: colors.neutral.neutral30,
          focusClearIcon: colors.neutral.neutral30,
          searchIcon: colors.neutral.black,
          focusSearchIcon: colors.neutral.black
        }
      },
      stepper: {
        labelActive: colors.neutral.neutral80,
        labelActiveHover: colors.neutral.black,
        labelDisabled: colors.neutral.neutral20,
        labelDisabledHover: colors.neutral.neutral20,
        stepCircleLabelActive: colors.neutral.white,
        stepCircleLabelDisabled: colors.neutral.white,
        stepCircleActiveBg: colors.coreColors.blue,
        stepCircleActiveBgHover: colors.dataVisualization.electricBlue.electricBlue600,
        stepCircleCompletedBg: colors.coreColors.blue,
        stepCircleDisabledBg: colors.neutral.neutral20,
        stepCircleDisabledBgHover: colors.neutral.neutral20,
        chevronActive: colors.coreColors.blue,
        chevronDisabled: colors.neutral.neutral20
      },
      badge: {
        backgroundColor: {
          default: colors.neutral.neutral10,
          highlight: colors.coreColors.blue,
          disabled: colors.neutral.neutral10,
          success: colors.feedback.solid.success,
          error: colors.feedback.solid.danger,
          warning: colors.feedback.solid.warning
        },
        badgeValue: {
          default: colors.neutral.neutral80,
          highlight: colors.neutral.white,
          disabled: colors.neutral.neutral20,
          success: colors.neutral.white,
          error: colors.neutral.white,
          warning: colors.coreColors.deepBlue
        }
      },
      textTag: {
        backgroundColor: {
          default: colors.neutral.neutral10,
          highlight: colors.coreColors.blue,
          success: colors.feedback.solid.success,
          error: colors.feedback.solid.danger,
          warning: colors.feedback.solid.warning,
          disabled: colors.neutral.neutral10,
          selected: colors.neutral.neutral80
        },
        textColor: {
          default: colors.neutral.neutral80,
          highlight: colors.neutral.white,
          success: colors.neutral.white,
          error: colors.neutral.white,
          warning: colors.neutral.neutral80,
          selected: colors.neutral.white,
          disabled: colors.neutral.neutral54
        }
      },
      progressBar: {
        barBackground: colors.neutral.neutral5,
        light: {
          label: colors.neutral.neutral54,
          barColor: colors.coreColors.blue
        },
        dark: {
          label: colors.neutral.white,
          barColor: colors.coreColors.cyan
        }
      },
      slider: {
        background: colors.neutral.neutral5,
        active: colors.coreColors.blue
      },
      contentSwitcher: {
        backgroundColor: colors.neutral.neutral5,
        itemTextColor: colors.neutral.neutral80,
        selectedItemTextColor: colors.neutral.white,
        hoverBackgroundColor: colors.neutral.neutral10,
        selectedBackgroundColor: colors.coreColors.blue,
        dividerColor: colors.neutral.neutral
      },
      chip: {
        textColor: colors.neutral.neutral80,
        background: colors.neutral.neutral10,
        border: colors.neutral.neutral10,
        textColorHover: colors.neutral.neutral80,
        backgroundHover: colors.neutral.neutral,
        borderHover: colors.neutral.neutral,
        disabledTextColor: colors.neutral.neutral54,
        disabledBackground: colors.neutral.neutral5,
        disabledBorder: colors.neutral.neutral5,
        selectedTextColor: colors.neutral.white,
        selectedBackground: colors.neutral.neutral80,
        selectedBorder: colors.neutral.neutral80,
        selectedTextColorHover: colors.neutral.white,
        selectedBackgroundHover: colors.neutral.neutral70,
        selectedBorderHover: colors.neutral.neutral70,
        selectedDisabledTextColor: colors.neutral.white,
        selectedDisabledBackground: colors.neutral.neutral54,
        selectedDisabledBorder: colors.neutral.neutral54,
        closeIconColor: colors.neutral.neutral80,
        closeIconColorHover: colors.neutral.neutral70,
        selectedCloseIconColor: colors.neutral.white,
        selectedCloseIconColorHover: colors.neutral.white,
        disabledCloseIconColor: colors.neutral.neutral54,
        selectedDisabledCloseIconColor: colors.neutral.white,
        leadingIconColor: colors.neutral.neutral80,
        selectedLeadingIconColor: colors.neutral.white,
        disabledLeadingIconColor: colors.neutral.neutral80,
        selectedDisabledLeadingIconColor: colors.neutral.white
      },
      iconButton: {
        iconColor: colors.neutral.neutral70,
        backgroundColor: 'transparent',
        iconHoverColor: colors.neutral.neutral80,
        backgroundHoverColor: colors.neutral.neutral5,
        iconActiveColor: colors.neutral.neutral80,
        backgroundActiveColor: 'transparent',
        iconDisabledColor: colors.neutral.neutral20,
        backgroundDisabledColor: 'transparent',
        iconSelectedColor: colors.coreColors.blue
      }
    },
    ...extra
  };
  return (0, _lodash.default)(theme, overrides);
};
exports.createMDSTheme = createMDSTheme;
const mds = exports.mds = createMDSTheme();